import {cs}                       from "@Common/react/chain-services";
import {scopedState}              from "@Common/react/scoped-state";
import {UseState}                 from "@Common/react/use-state";
import {setCurrentToSaved}        from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {cnv, gnv, setNestedValue} from "@Common/utils/arr-path";
import {chain}                    from "@Common/utils/fs";

export const ScQuantityLogic = ({initEnrollment, path, defaultValue, enabled, next}) => cs(

    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            gnv(initEnrollment, path) ?? defaultValue,
            (_) => ({
                saved  : _,
                current: _,
            })
        ),
        next,
    })],

    ({state}) => next({
        state: scopedState(state, ["current"]),
        quantity: !enabled ? null : state.value.current,
        clearEnrollmentEditor: {
            $name: "clear unaddressed-copies quantity",
            valid: true,
            prepareSave: (enrollment) => ({
                newValue: cnv(enrollment, path, () => null),
            }),
        },
        enrollmentEditor: enabled && {
            $name: "unaddressed-copies quantity",
            valid: true,
            changed: state.value.saved !== state.value.current,
            prepareSave: (enrollment) => ({
                newValue: setNestedValue(enrollment, path, state.value.current),
                onSaved: () => setCurrentToSaved(state),
            }),
        },
    }),
);

